import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sewing-machine",
  "use": "icon-si-glyph-sewing-machine-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-si-glyph-sewing-machine\">\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <path d=\"M16.875,2.125 L15.547,2.125 C14.93,1.461 13.747,1 12.958,1 L12.958,0.042 L12,0.042 L12,1 L4.042,1 C2.938,1 2.042,1 2.042,2 L2.042,3.875 C2.042,4.979 2.933,5.875 4.031,5.875 L4.031,5.875 L4.031,7 L3,7 L3,8 L5,8 L5,10 L5.958,10 L5.958,5.875 L6.011,5.875 C6.511,5.875 6.737,5.46 6.848,4.918 L6.987,4.05 C7.006,3.676 6.968,4.305 6.987,4 L11,4 L11,11.042 L3.042,11.042 C1.938,11.042 1.042,11.938 1.042,13.042 L1.042,13.958 C1.042,15.062 1.938,14.958 3.042,14.958 L13.958,14.958 C15.062,14.958 15.958,15.062 15.958,13.958 L15.958,13.917 L15.958,5.875 L16.875,5.875 L16.875,2.125 L16.875,2.125 Z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sewing-machine.svg
// module id = 36dW
// module chunks = 62